import { useTranslation } from 'react-i18next'
import { Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  /** Say what happens and what is not lost (PADROES-UI section 4). */
  body: string
  confirmLabel: string
  busy?: boolean
  error?: string | null
  destructive?: boolean
  children?: React.ReactNode
  onConfirm: () => void
}

/** A confirmation with the project's modal rules: gutter on a phone, footer with a gap, full-width buttons. */
export const ConfirmDialog = ({ open, onOpenChange, title, body, confirmLabel, busy = false, error, destructive = true, children, onConfirm }: Props) => {
  const { t } = useTranslation('bookings')
  return (
    <Dialog open={open} onOpenChange={(next) => { if (!busy) onOpenChange(next) }}>
      <DialogContent className="max-h-[90dvh] w-[calc(100%-1.5rem)] max-w-md overflow-y-auto p-4 sm:p-6">
        <div className="min-w-0 space-y-4">
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            <DialogDescription>{body}</DialogDescription>
          </DialogHeader>
          {children}
          {error && <div role="alert" className="rounded-lg bg-red-50 p-3 text-sm text-red-600">{error}</div>}
          <DialogFooter className="gap-2">
            <Button type="button" variant="outline" className="w-full sm:w-auto" disabled={busy} onClick={() => onOpenChange(false)}>{t('common:cancel')}</Button>
            <Button type="button" variant="secondary" disabled={busy} onClick={onConfirm}
              className={destructive ? 'w-full gap-2 bg-red-600 text-white hover:bg-red-700 sm:w-auto' : 'w-full gap-2 sm:w-auto'}>
              {busy && <Loader2 className="h-4 w-4 animate-spin" />}{confirmLabel}
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  )
}
